import PropTypes from 'prop-types'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'
import Hidden from '@material-ui/core/Hidden'
import Paper from '@material-ui/core/Paper'
import Button from '@material-ui/core/Button'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'
import MatchPlayScores from '@components/match-play-scores'
import MatchPlayPlayer from '@components/match-play-player'
import ThruOrTeetime from '@components/thru-or-teetime'
import { UsaFlag, EuroFlag } from '@components/atoms/flags'
import useStyles from './match-play-item.styles'

const MatchPlayItem = (props) => {
  const {
    item,
    isEmbedView,
    fullCoverageUrl,
    matchNumber,
  } = props

  const usaPlayers = item.filter(player => player.teamName === 'USA')
  const intlPlayers = item.filter(player => player.teamName === 'INTL')
  const isSinglePlayer = usaPlayers.length === 1

  const defineScores = (player) => {
    if (player.finalMatchScore === 'CON' && player.matchWinner) return 'w'
    if (player.finalMatchScore === 'CON' && !player.matchWinner) return 'c'
    return player.thru === 'F' ? player.finalMatchScore : player.currentMatchScore
  }

  const usaScores = defineScores(usaPlayers && usaPlayers[0])
  const intlScores = defineScores(intlPlayers && intlPlayers[0])
  const usaIsLeader = usaPlayers && usaPlayers[0].matchLeader
  const intlIsLeader = intlPlayers && intlPlayers[0].matchLeader
  const usaIsWinner = usaPlayers && usaPlayers[0].matchWinner
  const intlIsWinner = intlPlayers && intlPlayers[0].matchWinner
  const thru = usaPlayers && usaPlayers[0].thru
  const teeTime = usaPlayers && usaPlayers[0].teeTime

  const defineClassName = (score, isLeader, isWinner) => {
    if (!score) return 'neutral'
    if (isWinner) return 'winner'
    if (score === 'T') return 'leader'
    return isLeader ? 'leader' : 'neutral'
  }

  const defineAddClassName = (player) => {
    if (player.matchWinner) return 'winner'
    return ''
  }

  const intlClassName = defineClassName(intlScores, intlIsLeader, intlIsWinner)
  const usaClassName = defineClassName(usaScores, usaIsLeader, usaIsWinner)

  const intlAddClassName = defineAddClassName(intlPlayers && intlPlayers[0])
  const usaAddClassName = defineAddClassName(usaPlayers && usaPlayers[0])

  const styles = useStyles({ isSinglePlayer })

  return (
    <>
      <Hidden mdUp implementation="css">
        <Paper elevation={2} className={styles.root}>
          <Box className={styles.mobileHeader}>
            <Typography
              color="textSecondary"
              variant="overline"
            >
              Match {matchNumber}
            </Typography>
            <ThruOrTeetime
              thru={thru}
              teeTime={teeTime}
              isEmbedView={isEmbedView}
            />
          </Box>
          <Box className={`${styles.mobileBase} ${usaClassName} usa`}>
            <UsaFlag className={styles.mobileFlag} />
            <MatchPlayScores
              score={usaScores}
              thru={thru}
              isLeader={usaIsLeader}
              country="usa"
            />
            {usaPlayers.map(player => (
              <MatchPlayPlayer key={player.playerId} player={player} />
            ))}
          </Box>
          <Box className={`${styles.mobileBase} ${intlClassName} intl`}>
            <EuroFlag className={styles.mobileFlag} />
            <MatchPlayScores
              score={intlScores}
              thru={thru}
              isLeader={intlIsLeader}
              country="intl"
            />
            {intlPlayers.map(player => (
              <MatchPlayPlayer key={player.playerId} player={player} />
            ))}
          </Box>
          {isEmbedView && (
            <Button
              href={fullCoverageUrl}
              className={styles.action}
              endIcon={<ChevronRightIcon />}
            >
              View Match Details
            </Button>
          )}
        </Paper>
      </Hidden>
      <Hidden smDown implementation="css">
        <Box className={styles.root}>
          <Typography
            gutterBottom
            color="textSecondary"
            variant="h6"
          >
          Match {matchNumber}
          </Typography>
          <Box className={styles.baseWrapper}>
            <Box
              className={`${styles.teamWrapper} ${usaAddClassName} usa`}
              justifyContent="flex-start"
            >
              <UsaFlag className={styles.flag} />
              {usaPlayers.map(player => (
                <MatchPlayPlayer key={player.playerId} player={player} />
              ))}
              <MatchPlayScores
                score={usaScores}
                thru={thru}
                isLeader={usaIsLeader}
                country="usa"
                justifyContent="flex-start"
              />
            </Box>
            <ThruOrTeetime
              thru={thru}
              teeTime={teeTime}
              isEmbedView={isEmbedView}
            />
            <Box
              className={`${styles.teamWrapper} ${intlAddClassName} intl`}
              justifyContent="flex-end"
            >
              <MatchPlayScores
                score={intlScores}
                thru={thru}
                isLeader={intlIsLeader}
                country="intl"
                justifyContent="flex-end"
              />
              {intlPlayers.map(player => (
                <MatchPlayPlayer key={player.playerId} player={player} />
              ))}
              <EuroFlag className={styles.flag} />
            </Box>
          </Box>
        </Box>
      </Hidden>
    </>
  )
}

MatchPlayItem.propTypes = {
  item: PropTypes.array,
  isEmbedView: PropTypes.bool,
  fullCoverageUrl: PropTypes.string,
  matchNumber: PropTypes.number,
}

export default MatchPlayItem
